import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { UserInfoModel } from '../models/account-info.model';
import { AuthService } from './auth.service';

export const userInfoResolver: ResolveFn<UserInfoModel> = () => {
  return inject(AuthService).getUserInfo();
};
